import Reveal from '../../../common/components/Reveal/Reveal';
import { IconBriefcase, IconMonitor, IconNewspaper, IconRadio, IconUsers } from '../../../common/icons';

import '../styles/audiences.css';

const AUDIENCES = [
    { label: 'Medios digitales',       Icon: IconMonitor },
    { label: 'Emisoras',               Icon: IconRadio },
    { label: 'Portales de noticias',   Icon: IconNewspaper },
    { label: 'Creadores de contenido', Icon: IconUsers },
    { label: 'Marcas corporativas',    Icon: IconBriefcase },
];

export default function Audiences() {
    return (
        <section className="audiences" aria-label="A quién acompañamos">
            <Reveal className="audiences__inner layout-container">
                <p className="audiences__title">Acompañamos a</p>
                <ul className="audiences__list">
                    {AUDIENCES.map(({ label, Icon }) => (
                        <li key={label} className="audiences__item">
                            <span className="audiences__icon"><Icon /></span>
                            {label}
                        </li>
                    ))}
                </ul>
            </Reveal>
        </section>
    );
}
